<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-container fluid>
                <!-- 1st row : communication date & recontact date -->
                <v-row>
                    <v-col>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="Date"
                            rules="required"
                            :label="$t('lang_DATUM')"
                            :alvqa="alvqa + '-datepicker-comms-date'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="RecontactDate"
                            :label="$t('lang_AZ_COMMUNICATION_LIST_RECONTACT')"
                            :alvqa="alvqa + '-datepicker-recontact-date'"
                        />
                    </v-col>
                </v-row>

                <!-- 2nd row : communication type & status -->
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Type"
                            :items="commsType"
                            rules="required" 
                            :label="$t('lang_AZ_COMMUNICATION_LIST_CHANNEL')" 
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-type'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Status"
                            :items="yesNoItems"
                            :label="$t('lang_GENERIC_CAPTIONS_DONE')"
                            :selection="true"
                            rules="required"
                            :clearable="false"
                            :alvqa="alvqa + '-dropdown-status'"
                        />                
                    </v-col>
                </v-row>

                <!-- 3rd row : communication notes & recontact hook -->
                <v-row>
                    <v-col>
                        <BaseEditPageTextarea 
                            :context="context"
                            field="Notes"
                            rows="3"
                            :label="$t('lang_GENERIC_CAPTION_NOTES')"
                            :alvqa="alvqa + '-textfield-notes'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextarea
                            :context="context"
                            field="RecontactHook"
                            rows="3"
                            :label="$t('lang_AZ_COMMUNICATION_LIST_HOOK')"
                            :alvqa="alvqa + '-textarea-recontact-hook'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'

import { DropdownAzPersonsCommunicationsType, DropdownGenericYesNo } from '@/assets/dropdowns/alvDropdowns.js'


export default {
    name: "CommunicationListEditDialog",
    components: {
        EditingDialog,
        BaseEditPageDatePicker,
        BaseEditPageDropdown,
        BaseEditPageTextarea,
    },
    data() {
        return {
            context: "AzPersonsCommunication",
            alvqa: "az-persons-edit-form-communication-dialog",
        }
    },
    computed: {
        yesNoItems() { return DropdownGenericYesNo },
        commsType() { return DropdownAzPersonsCommunicationsType }

    },
    methods: {

    }
}
</script>